export const PayScheJSONSchema = {
  type: 'object',
  properties: {
    visitScheduleId: {
      type: 'string',
      description: 'OD',
    },
    custPoId: {
      type: 'string',
    },
    payTermsCode: {
      type: 'string',
    },
    orPayStat: {
      type: 'string',
    },
  },
}

export const PayScheJSONUiSchema = {
  type: 'VerticalLayout',
  className: 'identification-filters',
  elements: [
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/visitScheduleId',
          component: 'ReadOnlyFieldWithJson',
          label: 'Visit Schedule ID',
        },
        {
          type: 'Control',
          scope: '#/properties/custPoId',
          component: 'ReadOnlyFieldWithJson',
          label: 'Customer PO ID',
        },
        {
          type: 'Control',
          scope: '#/properties/payTermsCode',
          component: 'ReadOnlyFieldWithJson',
          label: 'Payment Terms Code',
        },
      ],
    },
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/orPayStat',
          component: 'ReadOnlyFieldWithJson',
          label: 'Order Payment Status',
        },
      ],
    },
  ],
}
